import { request, requestFd } from '@/common/request';
import { getTokenParams } from '@/config/base';

const notifyPrefix = '/hospital';
// 获取申请通知列表
export const getPageNotify = (params: any) => {
  return request.post<any, any>(`${notifyPrefix}/systemNotify/pageApplyNotify`, params, {
    // @ts-ignore
    isReturnAllData: true,
  });
};
// 获取入组申请详情
export const getApplyMsgDetail = (contractId: string) => {
  const url = `${notifyPrefix}/notify/intoGroupApply/${contractId}/contractFile`;
  return request.get(url);
};
// 获取服务预约申请详情
export const getServiceMsgDetail = (appointmentId: string) => {
  const url = `${notifyPrefix}/serviceTask/detail/${appointmentId}`;
  return request.get(url);
};
// 审批入组申请
export const handleNotify = (params: any) => {
  return request.post<any, any>(`${notifyPrefix}/notify/handleNotify`, params);
};
// 同意预约申请
export const httpAgreeServiceTask = (params: any) => {
  return request.post<any, any>(`${notifyPrefix}/serviceTask/agree`, params);
};
// 拒绝预约
export const httpRejectServiceTask = (params: any) => {
  return request.post<any, any>(`${notifyPrefix}/serviceTask/reject`, params);
};
// 取消预约
export const httpCancelServiceTask = (params: any) => {
  return request.post<any, any>(`${notifyPrefix}/serviceTask/cancel`, params);
};

export const httpGetUnreadMsg = () => {
  // @ts-ignore
  return request.get<any, any>(`${notifyPrefix}/systemNotify/unreadCountGrouping`);
};

export const httpOrderFileList = (orderId: string) => {
  // @ts-ignore
  return request.get<any, any>(`${notifyPrefix}/notify/intoGroupApply/information/${orderId}`);
};

export default {};
